<template>
  <v-tabs :background-color='backgroundColor'
          dark
          :value="activeTab"
          height="60"
          slider-size="4"
          class="general-tabs"
          active-class="active-tab"
          :slider-color="sliderColor"
          :centered="centered">

    <slot name="pre-tabs" />

    <v-tab :ripple="false"
           :transition="false"
           :reverse-transition="false"
           v-for="(tab, index) in tabs"
           :style="{ color: '#000000', opacity: activeTab !== index ? '0.54' : '1'}"
           :key="tab.key"
           :class="activeTabClass"
           @click="onTabClick(tab)"
           v-bind:tab="tab.id">

      <v-tooltip bottom
                 content-class="tabs-tooltip"
                 :disabled="!tabTooltip">
        <template v-slot:activator="{ on, attrs }">

          <div class="general-tabs-tab"
               v-on-hover-color="{color: onHoverColor, disabled: disableHover}"
               v-bind="attrs"
               v-on="on">
            <slot name="tabTitle"
                  v-bind:tab="tab"
                  v-bind:index="index"
                  v-bind:activeTitleColor="activeTitleColor"
                  v-bind:activeTab="activeTab">
              <span class="tab-title"
                    :style="{color: activeTab === index ? activeTitleColor : 'inherit'}">
                {{tab.labelKey ? $t(tab.labelKey) : tab.label}}
              </span>
            </slot>
          </div>

        </template>

        <span>{{tab.labelKey ? $t(tab.labelKey) : tab.label}}</span>

      </v-tooltip>

    </v-tab>

    <v-tabs-items :value="activeTab"
                  :touchless="touchless">
      <slot/>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
  export default {
    name: 'GeneralTabs',
    props: {
      tabs: {
        type: Array
      },
      activeTab: {
        type: Number,
      },
      touchless: Boolean,
      sliderColor: {
        type: String,
        default: '#e07b38'
      },
      activeTitleColor: {
        type: String,
        default: 'rgba(0,0,0,.87)'
      },
      onHoverColor: {
        type: String
      },
      removeBackgroundColor: {
        type: Boolean,
        default: false
      },
      disableHover: {
        type: Boolean,
        default: true
      },
      tabTooltip: {
        type: Boolean,
        default: false
      },
      centered: {
        type: Boolean,
        default: false,
      },
      backgroundColor: {
        type: String,
        default: '#fafafa'
      }
    },
    computed: {
      activeTabClass() {
        return this.removeBackgroundColor ? 'no-background-color' : ''
      }
    },
    methods: {
      onTabClick(tab) {
        this.$emit('tab-clicked', tab);
      }
    }
  }
</script>

<style lang="scss">
  @import "@/assets/scss/components/tabs.scss";
  @import "@/assets/scss/abstract/_i18n-mixins.scss";
  @import "@/assets/scss/abstract/_variables.scss";

  .general-tabs {
    height: 100%;

    .general-tabs-tab {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s;

      * {
        color: inherit;
      }

      .tab-icon:not(:last-child) {
        @include i-margin-mirror(0, 5px);
      }
    }

    &.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev.v-slide-group__prev--disabled {
      display: none;
    }

    .v-tabs__wrapper {
      box-shadow: 0px 1px 0 0 rgba(185, 185, 185, 0.4), 0px 2px 4px 0 rgba(0, 0, 0, 0.26);
    }

    .v-tabs__div {
      text-transform: none;
      font-family: var(--font2);
      font-size: 14px;
      font-weight: 600;
      padding: 0px 17px;
    }

    .v-tab.active-tab.v-tab--active:before,
    .v-tab--active.v-tab:not(:focus)::before {
      opacity: 0.04;
    }

    .no-background-color.v-tab.active-tab.v-tab--active:before,
    .no-background-color.v-tab--active.v-tab:not(:focus)::before {
      opacity: 0 !important;
    }

    &.theme--dark.v-tabs .no-background-color.v-tab:hover::before {
      opacity: 0;
    }

    .v-window {
      height: 100%;
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;

      &.theme--light.v-tabs-items {
        background: inherit;
      }

      .v-window__container {
        height: 100%;
        margin: 0 auto;

        .v-window-item {
          height: 100%;
          background-color: inherit;
        }
      }
    }
  }
</style>
